<template>
  <div class="setting-auto-flow-table-wrapper">
    <table class="disp-scroll">
      <thead>
        <tr>
          <th>アクション名</th>
          <th>アクションのタイミング</th>
          <th>アクション対象</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <!-- アクション名 -->
          <td>
            <p v-if="recruitFlowActionObj" @click="toggleAutoFlowModal(true)" class="select-action">
              {{ recruitFlowActionObj.name }}
            </p>
            <button v-else @click="toggleAutoFlowModal(true)" class="button is-small">選択</button>
          </td>
          <!-- アクションのタイミング -->
          <td>
            <!-- アクションタイミング選択 -->
            <select
              class="select is-small"
              v-model="recruitingActionSelected"
              @change="resetRecruitingSelected()"
            >
              <option :value="i" v-for="(action, i) in actionTiming" :key="action.id">
                {{ action }}
              </option>
            </select>
          </td>
          <!-- アクション対象 -->
          <td>
            <div style="width: 118px"></div>
            <!-- 媒体選択 -->
            <v-select
              class="select-target is-small"
              v-if="isRecruitingMedia && companyRecruit.length > 0"
              appendToBody
              multiline
              :calculate-position="(dropdownList, component, {width, top, left}) => {
                dropdownList.style.top = top;
                dropdownList.style.left = left;
                dropdownList.style.width = width;
                dropdownList.style.fontSize = '12px';
              }"
              v-model="recruitingMediaSelected"
              :options="settingMediaList"
              label="name" :reduce="rec => rec"
              :components="{Deselect: {render: createElement => createElement('span', '')}}"
              :disabled="disabledRecruitingMedia"
            />
            <!-- アクションタイミングが応募者管理画面反映時で、媒体連携設定がないときに表示 -->
            <p v-if="recruitingActionSelected === 0 && companyRecruit.length <= 0">先に媒体連携を設定してください</p>
            <!-- ロボ選択 -->
            <v-select
              class="select-target is-small"
              v-if="isGoal"
              appendToBody
              :calculate-position="(dropdownList, component, {width, top, left}) => {
                dropdownList.style.top = top;
                dropdownList.style.left = left;
                dropdownList.style.width = width;
                dropdownList.style.fontSize = '12px';
              }"
              v-model="recruitingChatBotSelected"
              :options="chatbots"
              label="name" :reduce="robo => robo.bot_id"
              :components="{Deselect: {render: createElement => createElement('span', '')}}"
              :disabled="chatbots.length < 1"
            />
          </td>
          <!-- ボタン -->
          <td>
            <button
              @click="register"
              class="button is-small is-primary"
            >
              登録
            </button>
          </td>
        </tr>
        <!-- 登録済み自動採用フロー一覧 -->
        <tr v-for="(flow, i) in autoFlowList" :key="i">
          <!-- アクション名 -->
          <td>
            {{ flow.action.name }}
          </td>
          <!-- タイミング -->
          <td>
            {{ actionTiming[flow.timing] }}
          </td>
          <!-- アクション対象 -->
          <template>
            <!--  -->
            <td v-if="flow.type || flow.type === 0">
              <!-- 自動採用フローに設定されている媒体が、媒体連携設定に1つも存在しない場合に赤文字で注意書きを表示 -->
              <p class="nothing-color" v-if="checkMedia(flow) === false">媒体連携未設定の媒体です</p>
              <!-- 自動採用フローに設定されている媒体が、媒体連携設定に1つも存在しない場合に赤文字で媒体名を表示 -->
              <p :class="{'nothing-color': checkMedia(flow) === false}">{{ recruitList.find(rec => rec.type == flow.type).name }}</p>
            </td>
            <td v-else-if="flow.chatbot">
              {{ flow.chatbot.name }}
            </td>
            <td v-else></td>
            <td>
              <button @click="deleteFlow(flow)" class="button is-small is-danger">削除</button>
            </td>
          </template>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import controlLogMixin from '@/mixins/controlLogMixin'
export default {
  props: {
    toggleAutoFlowModal: {
      type: Function,
      required: true,
      default: () => null,
    },
    createAutoFlow: {
      type: Function,
      required: true,
      default: () => null,
    },
    deleteAutoFlow: {
      type: Function,
      required: true,
      default: () => null,
    },
    recruitList: {
      type: Array,
      required: true,
      default: () => [],
    },
    recruitFlowActionObj: {
      required: false,
    },
    selectAutoFlowAction: {
      required: false,
      default: null
    },
    actionTiming: {
      type: Array,
      required: true,
      default: () => [],
    },
    autoFlowList: {
      type: Array,
      required: true,
      default: () => [],
    },
    companyRecruit: {
      type: Array,
      required: true,
      default: () => [],
    },
    chatbots: {
      type: Array,
      required: true,
      default: () => [],
    }
  },
  mixins: [
    controlLogMixin
  ],
  data() {
    return {
      // 選択中アクションタイミング
      recruitingActionSelected: null,
      // 選択中ロボ
      recruitingChatBotSelected: null,
      // 選択中媒体
      recruitingMediaSelected: null,
      // 媒体選択プルダウン表示フラグ
      disabledRecruitingMedia: false,
      // 媒体連携設定リスト
      settingMediaList: [],
    }
  },
  computed: {
    isRecruitingMedia() {
      // 応募者管理画面反映時
      return this.recruitingActionSelected === 0
    },
    isGoal() {
      // ゴール通過時
      return this.recruitingActionSelected === 2
    },
  },
  methods: {
  /**
   * 媒体連携設定状況確認
   * @param {*} flow 自動採用フローオブジェクト
   */
    checkMedia(flow) {
      // 設定されている自動採用フローの媒体が連携設定されているか確認
      const mediaCount = this.companyRecruit.filter(
        (media) =>
          flow.timing === "0" &&
          media.type === flow.type
      ).length

      // 媒体連携設定数チェック
      if (mediaCount > 0) {
        // 連携設定が1つ以上あればOK
        return true
      }
      // 連携設定がなければNG
      return false
    },
    /**
     * 自動採用フロー登録
     */
    register() {
      this.sendControlLog('自動採用フロー追加', '採用フロー自動化設定にて、「登録」ボタンをクリックした。')
      // 登録用データ作成
      let media_type = null
      if (this.recruitingMediaSelected) {
        media_type = this.recruitingMediaSelected.type
      }
      const register_data = {
        action_id: this.selectAutoFlowAction,
        timing: String(this.recruitingActionSelected),
        bot_id: this.recruitingChatBotSelected,
        type: media_type,
      }
      // 自動採用フローアクション選択チェック
      if (this.selectAutoFlowAction === null) {
        alert("採用フローアクションが選択されていません。")
        return
      }
      // 自動採用フローアクション選択チェック
      if (this.recruitingActionSelected === null) {
        alert("アクションタイミングが選択されていません。")
        return
      }
      // 媒体選択チェック
      if (this.recruitingActionSelected === 0) {
        if (this.recruitingMediaSelected === null) {
          alert("対象の媒体が選択されていません。")
          return
        }
      }
      // ロボ選択チェック
      if (this.recruitingActionSelected === 2) {
        if (this.recruitingChatBotSelected === null) {
          alert("対象のロボが選択されていません。")
          return
        }
      }
      // 登録重複チェック
      const duplicateAutoFlow = this.autoFlowList.filter(
        (autoFlow) =>
          autoFlow.action.pk === register_data.action_id &&
          autoFlow.timing === register_data.timing &&
          autoFlow.chatbot === register_data.bot_id &&
          autoFlow.type === register_data.type
      )
      if (Boolean(duplicateAutoFlow.length)) {
        alert("この設定は既に登録済みです。")
        return
      }
      // 自動採用フロー登録
      this.createAutoFlow(register_data)
    },
    /**
     * 自動採用フロー削除
     * @param {*} flow 自動採用フローオブジェクト
     */
    deleteFlow(flow) {
      this.sendControlLog('自動採用フロー削除', '採用フロー自動化設定にて、「削除」ボタンをクリックした。\n削除確認にてキャンセルされた場合は、削除されなかった可能性があります。')
      this.deleteAutoFlow(flow.id)
    },
    /**
     * アクションタイミング変更時初期化
     */
    resetRecruitingSelected() {
      // 選択中ロボ初期化
      this.recruitingChatBotSelected = null
      // 選択中媒体初期化
      this.recruitingMediaSelected = null
      // 媒体選択プルダウン表示フラグ初期化
      this.disabledRecruitingMedia = false

      // アクションタイミングが応募者管理画面反映時の初期設定
      if (this.recruitingActionSelected === 0) {
        // 媒体連携設定がなければ初期設定なし
        if (this.companyRecruit.length === 0) {
          return
        }
        // 連携設定済み媒体リスト取得
        const mediaSettingList = Array.from(
          new Map(this.companyRecruit.map((rec) => [rec.type, rec])).values()
        )
        // 全連携可能媒体から、設定済み媒体に紐づくデータのリストを取得
        this.settingMediaList = this.recruitList.filter(
          (media) =>
            mediaSettingList.filter(
              (setting) =>
                media.type === setting.type
            ).length > 0
        )
        if (this.settingMediaList.length < 1) {
          // 連携設定済み媒体なし
          this.disabledRecruitingMedia = true
        } else {
          // 連携設定済み媒体がある場合は先頭の媒体を選択状態にする
          this.recruitingMediaSelected = this.settingMediaList[0]
          this.disabledRecruitingMedia = false
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.setting-auto-flow-table-wrapper {
  display: flex;
  justify-content: center;
  table td:not([align]),
  table th:not([align]) {
    text-align: center;
  }
  table {
    width: 100%;
    border-collapse: collapse;
    margin: 0 auto;
    display: block;
    //overflow: auto;
    table-layout: fixed;
  }
  tr {
    width: 100%;
  }
  td,
  th {
    padding: 8px;
    margin: auto;
    font-size: smaller;
    border-style: solid;
    border-width: 1px;
    border-color: black;
  }
  td {
    text-align: left;
    vertical-align: middle;
    overflow: scroll;
    padding: 8px;
  }
  td > div::-webkit-scrollbar {
    width: 5px;
    height: 5px;
    visibility: hidden;
  }
  th {
    color: #fff;
    background: #aa0066;
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 10000;
  }
  table tr:nth-child(odd) {
    background: #ffeeff;
  }
  table tr:nth-child(even) {
    background: #fafafa;
  }
  .select-action {
    color: blue;
    cursor: pointer;
  }
  .select-target {
    width: auto;
    font-size: 13.33px;
    background-color: white;
    /deep/ .vs__selected-options {
      flex-wrap: nowrap;
    }
  }
  .nothing-color {
    color: red;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/tables/SettingAutoFlowTable.vue